export default function urlFriendlyName(productName) {
    // convert the name to lowercase
    let urlName = productName.toLowerCase();
    // replace spaces with dashes
    urlName = urlName.replace(/ /g, '-');
    // remove any non-alphanumeric characters
    urlName = urlName.replace(/[^a-z0-9-]/g, '');
    // return the final URL-friendly name
    return urlName;
}
